<template>
  <div class="Wdgt-Auth-Module">
    <p class="Wdgt-Auth-Module__text">Вы уверены, что хотите выполнить выход из своего аккаунта?</p>
    <ButtonMain class="Wdgt-Auth-Module__button" :type="'alert'" :width="'100%'" :loading="get_isLoading" @click="toLogout">Выход</ButtonMain>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { performLogout } from '@shared/utils/auth/logout';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  //---------------------------------------
  import ButtonMain from '@shared/UI/Buttons/ButtonMain/ButtonMain.vue';
  //---------------------------------------
  const store = useStore();
  const router = useRouter();
  //---------------------------------------
  const get_isLoading = computed(() => store.state.AuthorizationSystem.isLoading);
  //---------------------------------------
  const toLogout = async () => {
    toChangeLoadingFlag(true);
    try {
      await performLogout(store, router);
      toCloseWidget();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      toChangeLoadingFlag(false);
    }
  };
  //---------------------------------------
  const toChangeLoadingFlag = (status) => store.commit('AuthorizationSystem/toChangeLoadingFlag', status);
  const toCloseWidget = () => store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.auth);
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>